import { render, staticRenderFns } from "./PartnersJoinWrite.vue?vue&type=template&id=effd94ec&scoped=true&"
import script from "./PartnersJoinWrite.vue?vue&type=script&lang=js&"
export * from "./PartnersJoinWrite.vue?vue&type=script&lang=js&"
import style0 from "./PartnersJoinWrite.vue?vue&type=style&index=0&id=effd94ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "effd94ec",
  null
  
)

export default component.exports